import SmartMateriaUITable from '../../../generic/SmartMateriaUITable'

/**
 * @typedef {import('../../../generic/utilities/objectStructures/home/home').Resource} Resource Resource object
 */

/**
 *
 * @param {object} props Props object
 * @param {Preset[]} props.presets Part presets
 * @param {function(Preset)} props.onRowClick Function to get the selected Preset in the table
 * @returns
 */
const SelectPreset = ({ presets, onRowClick }) => {
  const variableColumns = ['x', 'y', 'z', 'a', 'b', 'c'].map((variable) => {
    return {
      name: variable.toUpperCase(),
      field: variable
    }
  })

  const presetColumns = [...variableColumns]

  return (
    <SmartMateriaUITable
      columns={presetColumns}
      dataFetch={presets}
      onRowClick={(row) => {
        if (onRowClick && typeof onRowClick === 'function') {
          onRowClick(row)
        }
      }}
    />
  )
}

export default SelectPreset
